import { render, staticRenderFns } from "./AlignCustoms.vue?vue&type=template&id=c817c6b4"
import script from "./AlignCustoms.vue?vue&type=script&lang=js"
export * from "./AlignCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports